import type { FC } from 'react';
import React from 'react';

import { useCaseMatch } from './hooks/use-case-match';
import type { IProps } from './models';

export const Case: FC<IProps> = ({ children, type }) => {
    const isMatch = useCaseMatch(type);

    return isMatch ? <>{children}</> : null;
};
